import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import ShopperApproved from "./ShopperApproved";

const Footer = ({ fMenu }) => {
  const [year, setYear] = useState();
  const location = useLocation();

  useEffect(() => {
    getYear();
  }, []);

  const getYear = () => {
    setYear(new Date().getFullYear());
  };

  return (
    <footer className="notranslate" style={{ backgroundColor: "#111111" }}>
      <section className="lession section-padding mt-3">
        <div className="container">
          <ShopperApproved />
        </div>
      </section>
      <div className="container">
        <div className="row">
          <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-9 col-xxl-9 order-xl-1 my-auto">
            <ul className="list-unstyled">
              {fMenu &&
                fMenu.length &&
                fMenu.map((mData, mIndex) => {
                  if (mData.id !== 4) {
                    const slug =
                      mData.name === "Contact Us" ? "contact-us" : mData.slug;
                    return (
                      <li
                        key={mIndex}
                        className={
                          location.pathname === `/${slug}`
                            ? "link-menu active text-white down"
                            : "link-menu"
                        }
                      >
                        {mData.type === "url" ? (
                          <a
                            href={mData.external_url}
                            target="_blank"
                            rel="noreferrer"
                          >
                            {mData.name}
                          </a>
                        ) : (
                          <Link key={mIndex} to={`/${slug}`}>
                            {mData.name}
                          </Link>
                        )}
                      </li>
                    );
                  }
                })}
              <li>
                <Link className="" to={"/login"}>
                  Login
                </Link>
              </li>
            </ul>
          </div>
          <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-3 col-xxl-3 order-xl-0 ">
            <p>
              Metro Traffic School © {year}.
              <br />
              All Rights Reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
